import { Modal } from 'rimble-ui'
import CustomButton from '../CustomButton'

export default function ModalCancelListingResult(props) {
  const {toggleModal, fn} = props

  return (
    <>
      <Modal isOpen={toggleModal}>
        <div className='customModal modalSellConfirm modalSellResult'>
          <div className='nftInfo'>
            <div className='sellTitle'>CANCEL LISTING</div>
            <div className='sellResult'>You have canceled listing successfully</div>
          </div>
          <CustomButton 
            text={'See your NFT in the MyNFT'}
            fn={fn}
            type={'medium'}
            transparent={false}
            disabled={false}
          />
        </div>
      </Modal>
    </>
  )
}